import { CheckboxField } from "components/RenderInput"
import { vendors as VENDORS } from "config"
import { Input, Table } from "reactstrap"
import { Field } from "redux-form"

export const DEFAULT_FORM_FIELDS = [
  {
    name: "first_name",
    label: "First Name",
    required: false,
  },
  {
    name: "last_name",
    label: "Last Name",
    required: false,
  },
  {
    name: "email",
    label: "Email",
    required: false,
    hideFromVendors: [VENDORS.HARVARD_CLIENT_ID],
  },
]

export const FORM_FIELDS = [
  {
    name: "email",
    label: "Primary Email",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "harvard_email",
    label: "Harvard Email (for faster verification)",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  ,
  {
    name: "phone",
    label: "Phone",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.TPI_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IMAC_CLIENT_ID,
      VENDORS.TROTTA_CLIENT_ID,
      VENDORS.IFO_CLIENT_ID,
    ],
  },
  {
    name: "phone",
    label: "Mobile Number (w/County code)",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "languages",
    label: "Language(s)",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "gender",
    label: "Male/Female",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.TPI_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
    ],
  },
  {
    name: "date_of_birth",
    label: "DOB",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.TPI_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
    ],
  },
  {
    name: "occupation",
    label: "Sport/Occupation",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "occupation",
    label: "Occupation",
    required: false,
    vendors: [VENDORS.TPI_CLIENT_ID],
  },
  {
    name: "company_name",
    label: "Company Name",
    required: false,
    vendors: [VENDORS.TROTTA_CLIENT_ID],
  },
  {
    name: "country",
    label: "Country / Time zone",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "address",
    label: "Address",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.TPI_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IMAC_CLIENT_ID,
    ],
  },
  {
    name: "address",
    label: "Street Address",
    required: false,
    vendors: [VENDORS.TROTTA_CLIENT_ID],
  },
  {
    name: "city",
    label: "City",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IMAC_CLIENT_ID,
      VENDORS.TROTTA_CLIENT_ID,
      VENDORS.HARVARD_CLIENT_ID,
      VENDORS.IFO_CLIENT_ID,
    ],
  },
  {
    name: "chapter_attend_events",
    label: "Please Select A Chapter Where You Would Like To Attend Events",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "guest_speaker_question",
    label: "Please submit your question for our guest speaker",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "state",
    label: "State",
    required: false,
    vendors: [
      VENDORS.WESTERN_EDGE_CLIENT_ID,
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IMAC_CLIENT_ID,
      VENDORS.TROTTA_CLIENT_ID,
      VENDORS.IFO_CLIENT_ID,
    ],
  },
  {
    name: "state",
    label: "State/Province",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "location",
    label: "Location / Travels from",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "country",
    label: "Country",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "zip_code",
    label: "Zip Code",
    required: false,
    vendors: [VENDORS.TROTTA_CLIENT_ID],
  },
  {
    name: "zip_code",
    label: "Zip/Postal Code",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "zip_code",
    label: "Postal Code",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "business_name",
    label: "Name of Business",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "business_name",
    label: "Name of Business/Association",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID, VENDORS.G2_CLIENT_ID],
  },
  {
    name: "business_type",
    label: "Type of Business/Association Industry",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "business_address",
    label: "Business Address (Street, City, Zip Code)",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "business_address",
    label: "Business/Association Address (Street, City, Zip Code)",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID, VENDORS.G2_CLIENT_ID],
  },
  {
    name: "social_media_followers_number",
    label: "Number of Social Media Followers",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "business_website",
    label: "Website",
    required: false,
    vendors: [
      VENDORS.CAGER_CLIENT_ID,
      VENDORS.G2_CLIENT_ID,
      VENDORS.IFO_CLIENT_ID,
    ],
  },
  {
    name: "bio",
    label: "Bio",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "social_media",
    label: "Social Media @",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID, VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "college_name",
    label: "Name of College (if applicable)",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "team_name",
    label: "Team Name",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "age",
    label: "Age Level",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "coach_first_name",
    label: "Coach's First Name",
    required: false,
    vendors: [VENDORS.CAGER_CLIENT_ID],
  },
  {
    name: "have_scheduled_appointment_before",
    label: "Have you scheduled an appointment before? (yes/no)",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "have_referral_from_doctor",
    label: "Do you have a referral from a doctor? (yes/no)",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "referral_doctor_name",
    label: "If you have a referral, please enter your doctor's name",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "how_did_you_hear_about_us",
    label:
      "How did you hear about us? (Doctor/Family/Friend/Google/Social Media/TV/Newspaper/Other)",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "receive_newsletter",
    label: "Would you like to receive our newsletter? (yes/no)",
    required: false,
    vendors: [VENDORS.IMAC_CLIENT_ID],
  },
  {
    name: "receive_horseman_corral",
    label: "Would you like to receive the Horseman's Corral? (yes/no)",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "aqha_number",
    label: "Enter your AQHA#",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "family_members",
    label:
      "Add Family Members (First Name, Last Name, Email, AQHA#, Date of Birth (MM/DD/YY))",
    required: false,
    vendors: [VENDORS.WESTERN_EDGE_CLIENT_ID],
  },
  {
    name: "years_experience",
    label: "Years Experience",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "area_of_expertise",
    label: "Areas of Expertise",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "certifications",
    label: "Certifications",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "fees",
    label: "Fees",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "offered_program",
    label: "Program Offered",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "partial_client_list",
    label: "Partial client list",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "ideal_time_to_meet",
    label: "Ideal time to meet",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "personal_goal_for_joining_a_forum",
    label: "Personal goal for joining a forum",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "how_long_have_you_been_a_facilitator",
    label: "How long have you been a facilitator?",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "previous_forum_experience",
    label: "Previous forum experience",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "currently_in_a_forum",
    label: "Are you currently in a forum?",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "interested_in_being_a_moderator",
    label: "Would you be interested in being a moderator?",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "forum_placement_preference",
    label: "Forum placement preference",
    required: false,
    vendors: [VENDORS.IFO_CLIENT_ID],
  },
  {
    name: "harvard_affiliation",
    label: "Harvard Affiliation (Alumni, Faculty, Staff, Student, N/A)",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "harvard_school_department",
    label:
      "If You Are Harvard Faculty/Staff - Enter the Harvard School or Department",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "last_school_attended",
    label: "Last Harvard School Attended",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "degree",
    label: "Harvard Degree/Program",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "class_year",
    label: "Class Year (YYYY)",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "current_situation",
    label:
      "Type in the role or roles that currently describe(s) you (answer N/A if none apply to you): Founder / Working in a Start-up / Investor / C-suite Executive",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "current_organisation",
    label: "Current Organization",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "title",
    label: "Current Job Title",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
  {
    name: "social_media",
    label: "Linkedin Profile",
    required: false,
    vendors: [VENDORS.HARVARD_CLIENT_ID],
  },
]

export const renderFormFields = ({ fields, change }) => {
  return (
    <Table hover className="table-nowrap align-middle">
      <thead>
        <tr>
          <th>
            <Input
              type="checkbox"
              onChange={e => {
                for (let i = 0; i < fields?.length; i++) {
                  change(`${fields?.name}[${i}].checked`, e.target.checked)
                  if (!e.target.checked) {
                    change(`${fields?.name}[${i}].required`, false)
                  }
                }
              }}
            />
          </th>
          <th>Field</th>
          <th>Required</th>
        </tr>
      </thead>
      <tbody>
        {fields?.map((item, index) => {
          const data = fields.get(index)
          return (
            <tr
              key={index}
              style={data?.checked ? { backgroundColor: "WhiteSmoke" } : {}}
            >
              <td>
                <Field
                  name={`${item}.checked`}
                  component={CheckboxField}
                  onChange={(e, value) => {
                    if (!value)
                      change(`${fields?.name}[${index}].required`, false)
                  }}
                />
              </td>
              <td>
                <span>{data?.label}</span>
              </td>
              <td>
                <Field
                  name={`${item}.required`}
                  component={CheckboxField}
                  onChange={(e, value) => {
                    if (value) change(`${fields?.name}[${index}].checked`, true)
                  }}
                />
              </td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}
